import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { WindowService } from './window.service';

/**
 * Permet de télécharger un document du back
 */
@Injectable()
export class EnregistrerFichierService {

	constructor(private windowService: WindowService) {
	}

	/**
	 * Télécharge une response reçu du back
	 * @param {HttpResponse<any>} fichier
	 */
	telecharger(fichier: HttpResponse<any>) {
		const nativeWindow = this.windowService.getNativeWindow();
		const url = nativeWindow.URL.createObjectURL(fichier.body);
		const a = document.createElement('a');
		const filename = fichier.headers.get('Content-Disposition').split('filename=')[1];

		document.body.appendChild(a);
		a.setAttribute('style', 'display: none');
		a.href = url;
		a.download = filename;
		a.click();
		nativeWindow.URL.revokeObjectURL(url);
		a.remove();
	}
}
